var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "w-6 h-6",
    height: 48,
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.306 18.375C23.678 18.932 26.68 19 28 19c1.321 0 4.323-.068 6.695-.625L29 29.764V33h-2v-3.236l-5.694-11.389zM28 15c3.95 0 6.573.561 7.617 1-1.044.441-3.667 1-7.617 1-3.949 0-6.571-.559-7.616-1 1.045-.439 3.667-1 7.616-1zm3 20v-4.764l6.642-13.284c.226-.278.358-.593.358-.952 0-2.783-7.654-3-10-3-2.345 0-10 .217-10 3 0 .359.131.674.358.952L25 30.236V35h6zM4 2h5v2H6v40h3v2H4V2zm12 40h24v-2H16v2zm0-4h24v-2H16v2zm0-26h24v-2H16v2zm0-4h24V6H16v2zm-3 36h29V4H13v40zm-2 2h33V2H11v44z",
    fill: "#4D27AA",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlue);
export default __webpack_public_path__ + "static/media/glue.73a8c1b1f6176065359a3dbe0b92df98.svg";
export { ForwardRef as ReactComponent };